module.exports = __webpack_public_path__ + "static/media/info.63aff838.svg";